import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { EmptyAllocationManagersResponse } from './types';

const emptyAllocationManagersBaseAtom = atom(async () => {
  const response = await request.get<EmptyAllocationManagersResponse>(
    '/admin/empty_allocation_managers_query'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const emptyAllocationManagersLoadableAtom = loadable(
  emptyAllocationManagersBaseAtom
);
